import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineItemSelect from '../inputs/InlineItemSelect';
import InlineManufacturerSelect from '../inputs/InlineManufacturerSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const listifyStringToIntegers = (ids) => {
  if (!ids) {
    return [];
  }
  if (_.isArray(ids)) {
    return ids;
  }
  if (!ids.includes(',')) {
    return [parseInt(ids, 10)];
  }
  return _.map(ids.split(','), id_ => parseInt(id_, 10));
};

class EffectivePriceGuidance extends Component {
  constructor(props) {
    super(props);
    const { initialValues } = props;
    this.initialState = {
      percent: initialValues.percent || 2,
      included_manufacturer_ids: initialValues.included_manufacturer_ids || [],
      included_supplier_ids: initialValues.included_supplier_ids || [],
      included_item_ids: initialValues.included_item_ids || [],
      excluded_manufacturer_ids: initialValues.excluded_manufacturer_ids || [],
      excluded_supplier_ids: initialValues.excluded_supplier_ids || [],
      excluded_item_ids: initialValues.excluded_item_ids || [],
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
    _.bindAll(this, 'onSubmit', 'onReset');
  }

  onSubmit(event) {
    event.preventDefault();
    const {
      percent,
      included_manufacturer_ids,
      included_supplier_ids,
      included_item_ids,
      excluded_manufacturer_ids,
      excluded_supplier_ids,
      excluded_item_ids,
      regions
    } = this.state;
    this.props.onSubmit({
      kind: 'effective_price',
      regions: _.filter(regions),
      value: {
        percent: parseFloat(percent),
        included_manufacturer_ids: listifyStringToIntegers(included_manufacturer_ids),
        included_supplier_ids: listifyStringToIntegers(included_supplier_ids),
        included_item_ids: listifyStringToIntegers(included_item_ids),
        excluded_manufacturer_ids: listifyStringToIntegers(excluded_manufacturer_ids),
        excluded_supplier_ids: listifyStringToIntegers(excluded_supplier_ids),
        excluded_item_ids: listifyStringToIntegers(excluded_item_ids)
      }
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineSupplierSelect
          mode='multiple'
          showSearch={true}
          label='Included Suppliers'
          description='Suppliers to be included'
          placeholder='Suppliers to be included'
          value={this.state.included_supplier_ids}
          onChange={included_supplier_ids => this.setState({ included_supplier_ids })}
          include_all={false}
          include_any={false}
        />
        <InlineManufacturerSelect
          mode='multiple'
          showSearch={true}
          clearable={true}
          value={this.state.included_manufacturer_ids}
          label='Included Manufacturers'
          description='Manufacturers to be included'
          placeholder='Manufacturers to be included'
          onChange={included_manufacturer_ids => this.setState({ included_manufacturer_ids })}
        />
        <InlineItemSelect
          label='Included Item IDs'
          value={this.state.included_item_ids}
          onChange={included_item_ids => this.setState({ included_item_ids })}
        />
        <InlineSupplierSelect
          mode='multiple'
          label='Excluded Suppliers'
          description='Suppliers to not be included'
          placeholder='Suppliers to not be included'
          value={this.state.excluded_supplier_ids}
          onChange={excluded_supplier_ids => this.setState({ excluded_supplier_ids })}
          include_all={false}
          include_any={false}
        />
        <InlineManufacturerSelect
          mode='multiple'
          showSearch={true}
          clearable={true}
          value={this.state.excluded_manufacturer_ids}
          label='Excluded Manufacturers'
          description='Manufacturers to not be included'
          placeholder='Manufacturers to not be included'
          onChange={excluded_manufacturer_ids => this.setState({ excluded_manufacturer_ids })}
        />
        <InlineItemSelect
          label='Excluded Item IDs'
          value={this.state.excluded_item_ids}
          onChange={excluded_item_ids => this.setState({ excluded_item_ids })}
        />
        <InlineInputNumber
          label='Discount Percentage'
          description='Amount to discount off of each item'
          displayFormat='percent'
          value={this.state.percent}
          onChange={value => this.setState({ percent: value })}
        />
      </RuleForm>
    );
  }
}

EffectivePriceGuidance.defaultProps = {
  type: 'add',
  initialValues: {}
};

EffectivePriceGuidance.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default EffectivePriceGuidance;
